import { TOKEN_KEY, WHITE_LIST, JS_API_LIST } from 'src/constants'
import { postWxWorkAgentJsConfigApi, postWxWorkJsConfigApi } from 'src/service'
import * as wx from '@wecom/jssdk'

const { VUE_APP_ID, VUE_APP_AGENT } = process.env

console.log('开发 APP_ID', process.env, VUE_APP_ID, VUE_APP_AGENT)

/**
 * 自动登录
 */
export function handleLogin () {
  const { origin, pathname, search } = location
  const path = pathname.replace('/' + process.env.VUE_APP_BASE_NAME, '')
  localStorage.removeItem(TOKEN_KEY)
  // 若非白名单页面
  if (!WHITE_LIST.includes(path)) {
    const fromPath = encodeURIComponent(pathname.replace('/' + process.env.VUE_APP_BASE_NAME, '') + search)
    const redirectUri = encodeURIComponent(`${origin}/login?t=${Date.now()}&from=${fromPath}`)
    // 此选项备用
    const state = 'state'
    const oAuthDomain = 'https://open.weixin.qq.com/connect/oauth2/authorize'
    location.href = `${oAuthDomain}?appid=${VUE_APP_ID}&redirect_uri=${redirectUri}&response_type=code&state=${state}&scope=snsapi_base#wechat_redirect`
  }
}

/**
 * promise调用Api
 * @param api
 * @param data
 * @return {Promise<unknown>}
 * @constructor
 */
export function Invoke (api, data) {
  return new Promise((resolve, reject) => {
    console.log('Invoke ------>', api, data)
    wx[api]({
      ...data,
      success (res) {
        resolve(res)
      },
      fail (res) {
        reject({
          api,
          data,
          message: res.errMsg
        })
      }
    })
  })
}

/**
 * 初始化应用API
 * @return {Promise<unknown>}
 */

export async function initAgentConfig () {
  return new Promise((resolve, reject) => {
    wx.register({
      corpId: VUE_APP_ID,
      agentId: VUE_APP_AGENT,
      jsApiList: JS_API_LIST,
      getConfigSignature,
      getAgentConfigSignature,
      onAgentConfigSuccess (res) {
        console.log(res)
        resolve(res)
      },
      onAgentConfigFail (res) {
        console.warn('agent-config 失败', res)
        reject(res)
      }
    })
  })
}

async function getAgentConfigSignature (url) {
  // 根据 url 生成企业签名
  // 生成方法参考 https://developer.work.weixin.qq.com/document/14924
  const data = await postWxWorkAgentJsConfigApi({
    url: url,
    agentId: VUE_APP_AGENT
  })
  return { timestamp: data.timestamp, nonceStr: data.nonceStr, signature: data.signature }
}

async function getConfigSignature (url) {
  // 根据 url 生成企业签名
  // 生成方法参考 https://developer.work.weixin.qq.com/document/14924
  const data = await postWxWorkJsConfigApi({
    url: url,
    agentId: VUE_APP_AGENT
  })
  return { timestamp: data.timestamp, nonceStr: data.nonceStr, signature: data.signature }
}
